import React from 'react';
import { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AuthContext} from '../../App';

const PrivateRoute = ({ children, ...rest }) => {
  const [loggedInUser, setLoggedInUser] = useContext(AuthContext);

  return (

    <Route
      {...rest}
      render={({ location }) =>
        loggedInUser.email && loggedInUser.isSignedIn ? (
          children
        ) : (

            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
      }
    />
  );
};

export default PrivateRoute;